import type from './CustomModule.type';

const initialState = {
  customLibraryList: null,
  customGroupList: {},
  customLibraryDetail: {},
  customModuleGroupOption: [],
  customLibOptions: [],
  customItemDetails: null,
  libraryPages: [],
  customModulePageList: [],
  customModulePages: [],
  customModulePageControlList: [],
  customModuleDependentControls: [],
  customLibraryCalculationList: [],
  customLibraryPagesCalculationList: [],
  customLibraryPageControlsCalculationList: [],
};

const poTemplateReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.GET_CUSTOM_MODULE:
      return {
        ...state,
        customLibraryList: action.payload,
      };
    case type.GET_CUSTOM_MODULE_BY_ID:
      return {
        ...state,
        customLibraryDetail: action.payload,
      };
    case type.GET_CUSTOM_MODULE_OPTION:
      return {
        ...state,
        customLibOptions: action.payload,
      };
    case type.GET_CUSTOM_MODULE_GROUP:
      return {
        ...state,
        customGroupList: action.payload,
      };
    case type.UNMOUNT_LIBRARY_LIST:
      return {
        ...state,
        customLibraryList: {},
      };
    case type.UNMOUNT_GROUP_LIST:
      return {
        ...state,
        customGroupList: {},
      };
    case type.GET_CUSTOM_MODULE_FOR_OPTION:
      return {
        ...state,
        customItemDetails: action.payload,
      };
    case type.UNMOUNT_LIBRARY:
      return {
        ...state,
        customLibraryDetail: {},
        customModulePageList: [],
        customModulePageControlList: [],
        customModulePages: [],
        customModuleDependentControls: [],
      };
    case type.LIBRARY_PAGES:
      return {
        ...state,
        libraryPages: action.payload,
      };
    case type.GET_CUSTOM_MODULE_LIST:
      return {
        ...state,
        customModulePageList: action.payload,
      };
    case type.GET_CUSTOM_MODULE_PAGE_CONTROL_LIST:
      return {
        ...state,
        customModulePageControlList: action.payload,
      };
    case type.GET_CUSTOM_MODULE_PAGE_LIST:
      return {
        ...state,
        customModulePages: action.payload,
      };
    case type.GET_CUSTOM_MODULE_DEPENDENT_CONTROL_LIST:
      return {
        ...state,
        customModuleDependentControls: action.payload,
      };
    case type.GET_ALL_CUSTOM_MODULE_FOR_CALCULATION:
      return {
        ...state,
        customLibraryCalculationList: action.payload,
      };
    case type.GET_CUSTOM_MODULE_CALCULATION_PAGE_LIST:
      return {
        ...state,
        customLibraryPagesCalculationList: action?.payload?.pages || [],
      };
    case type.GET_CUSTOM_MODULE_PAGE_CONTROL_LIST_FOR_CALCULATION:
      return {
        ...state,
        customLibraryPageControlsCalculationList: action?.payload || [],
      };
    default:
      return state;
  }
};

export default poTemplateReducer;
